import BliIconSiSetting from '@blibli/blue-dls-library-icon/dist/Setting'
import BliIconSiPointsBlibli from '@blibli/blue-dls-library-icon/dist/PointsBlibli'
import BliIconSiCircleTierDiamond from '@blibli/blue-dls-library-icon/dist/CircleTierDiamond'
import BliLoaderSkeleton from '@blibli/blue.loader-skeleton/dist/loader-skeleton/blue/LoaderSkeleton'
import EngagementInfo from '@vue3/components/common/EngagementInfo/index.vue'
import CommonMixin from '@vue3/mixins/commonMixin.js'
import { mapActions, mapState } from 'pinia'
import RewardsStore from '@vue3/store/rewards-store.js'
import AuthStore from '@vue3/store/auth-store.js'
import BliIconSiChevronDown from '@blibli/blue-dls-library-icon/dist/ChevronDown'
import BliIconSiNotification from '@blibli/blue-dls-library-icon/dist/Notification'
import BliBadge from '@blibli/blue.badge/dist/badge/blue/Badge'
import CommonStore from '@vue3/store/common-store.js'
import BliOnboardingTooltip from '@blibli/blue.onboarding-tooltip/dist/onboarding-tooltip/blue/OnboardingTooltip'
import BliButton from '@blibli/blue.button/dist/button/blue/Button'
import { app } from '@vue3/configs'
const { routerName: { homePage } } = app


export default {
  name: 'AppHeader',
  components: {
    EngagementInfo,
    BliIconSiSetting,
    BliLoaderSkeleton,
    BliIconSiPointsBlibli,
    BliIconSiCircleTierDiamond,
    BliIconSiChevronDown,
    BliBadge,
    BliOnboardingTooltip,
    BliButton,
    BliIconSiNotification
  },
  mounted () {
    if (this.$route.name !== homePage) {
      this.fetchEngagementInfo()
    }
  },
  data () {
    return {
      enablePointsRetryOption: false,
      currentCompany: null
    }
  },
  mixins: [CommonMixin],
  computed: {
    ...mapState(RewardsStore, ['showLoyaltySectionLoader']),
    ...mapState(CommonStore, ['showOnboardingModal']),
    ...mapState(AuthStore, ['userDetails'])
  },
  methods: {
    ...mapActions(CommonStore, ['setShowOnboardingModal', 'setShowTenantPickerModal']),
    ...mapActions(RewardsStore, ['getEngagementInfo']),
    fetchEngagementInfo () {
      this.getEngagementInfo({
        param: { email: this.userDetails.email }
      })
    },
    handleCompanySwitchClick () {
      if (!this.isCompanySwitchAccesible) {
        return
      }
      this.setShowTenantPickerModal({ showModal: true, isTenantAlreadySelected: true })
    }
  }
}
